/*@ngInject*/
const LoginRepository = function (baseRepository, appTypeConfigurationModel, cryptoUtil) {

    angular.extend(this, baseRepository);

    this.login = (username, password, timeoutSeconds, passwordIsToken, isExternalToken) => {
        const url = '/rest/v2/Session',
              config = {
                  params: {
                      applicationId: appTypeConfigurationModel.getApplicationId(),
                      timeoutSeconds: timeoutSeconds,
                      passwordIsToken: passwordIsToken,
                      isExternalToken: isExternalToken
                  }
              },
              data = {
                  userName: username,
                  password: (passwordIsToken ? password : cryptoUtil.encryptWithServerPublicKey(password))
              };
        return this.post(url, data, config);
    };

    this.changePasswordAndLogin = function (username, oldPassword, newPassword, timeoutSeconds, passwordIsToken) {
        const url = '/rest/v2/Session',
              config = {
                  params: {
                      applicationId: appTypeConfigurationModel.getApplicationId(),
                      timeoutSeconds: timeoutSeconds,
                      passwordIsToken: passwordIsToken
                  }
              },
              data = {
                  userName: username,
                  password: cryptoUtil.encryptWithServerPublicKey(newPassword),
                  oldPassword: (passwordIsToken ? oldPassword : cryptoUtil.encryptWithServerPublicKey(oldPassword))
              };
        return this.post(url, data, config);
    };

    this.logout = () => {
        const url = '/rest/Session';
        return this.delete(url);
    };

    this.preDestroy = () => {
        const url = '/rest/Session/preDestroy';
        return this.post(url);
    };
};

angular.module('gw-um-auth')
    .service('loginRepository', LoginRepository);
